<template>
    <MainContent 
        title='Liquidaciones abonos'
    >
        <template v-slot:header>
            <b-button
                size="sm"
                :to="{name: 'back.liquidaciones.abonos.crear'}"
                class="mb-3 d-block d-md-inline"
            >
                Solicitar nueva liquidación
            </b-button>
        </template>
        <template v-slot:subheader>
            <FiltersBar @updateLiquidaciones="getLiquidaciones"/>
        </template>
        <template v-slot:content>
            <ContentOrLoading>
                <div class="row" v-if="liquidaciones">
                    <div class="col-12">
                        <b-table
                            striped
                            hover
                            :items="liquidaciones.data"
                            :fields="fields"
                            empty-text="No se ha encontrado ninguna liquidación"
                            responsive
                        >
                            <template #cell(estado)="data">
                                <b-badge pill :variant="getColorEstado(data.value)">{{ data.value | formatear_liquidacion_estado }}</b-badge>
                            </template>
                            <template #cell(importe_total)="data">
                                {{ data.value | formatear_precio }}
                            </template>
                            <template #cell(opciones)="data">
                                <b-dropdown 
                                    :id="'dropdown-' + data.item.id" text="Opciones" 
                                    class="m-md-2"
                                >
                                    <b-dropdown-item 
                                        v-if="data.item.estado == 0"
                                        @click="openSendForReviewModal(data.item)"
                                    >
                                        Solicitar liquidación
                                    </b-dropdown-item>
                                    <b-dropdown-item 
                                        :href="data.item.url_pdf + '&api_key=' + api_key" target="_blank" 
                                        v-if="data.item.estado == 2 || data.item.estado == 1"
                                    >
                                        Previsualizar en pdf
                                    </b-dropdown-item>
                                    <b-dropdown-item 
                                        v-if="data.item.estado == 0"
                                        @click="showModal('borrar-' + data.item.id)"
                                    >
                                        Borrar
                                    </b-dropdown-item>
                                </b-dropdown>
                                <BorrarLiquidacionModal
                                    :liquidacion="data.item"
                                    @close="closeModal"
                                />
                            </template>                        
                        </b-table>

                        <div class="mt-3">
                            <b-pagination
                                v-model="liquidaciones.meta.current_page"
                                :total-rows="liquidaciones.meta.total"
                                :per-page="per_page"
                                align="right"
                                size="sm"
                                @change="getLiquidaciones"
                            />
                        </div>
                    </div>
                </div>
            </ContentOrLoading>
            <SendForReviewModal
                :show="showSendForReviewModal"
                :disabled="sendingForReview"
                :observaciones="sendForReviewObservaciones"
                @close="closeSendForReviewModal"
                @confirm="sendForReview"
            />
        </template>
    </MainContent>
</template>

<script>
    import { getCurrentInstance } from 'vue';
    import { useSendForReview } from '@/composables/admin/liquidaciones/useSendForReview';
    import MainContent from '@/components/backend/components/MainContent';
    import ContentOrLoading from '@/components/backend/components/ContentOrLoading';
    import BorrarLiquidacionModal from '../../../../components/backend/liquidaciones/abonos/BorrarLiquidacionModal.vue';
    import FiltersBar from'@/components/backend/liquidaciones/common/FiltersBar.vue';
    import SendForReviewModal from '@/modules/admin/liquidaciones/components/SendForReviewModal.vue';

    export default {
        name: 'LiquidacionesAbonos',
        setup() {
            const instance = getCurrentInstance();
            const {
                showModal: showSendForReviewModal,
                sending: sendingForReview,
                observaciones: sendForReviewObservaciones,
                open: openSendForReviewModal,
                close: closeSendForReviewModal,
                submit: sendForReview,
            } = useSendForReview('back.liquidaciones.abonos.send.review', () => instance.proxy.getLiquidaciones(1));

            return {
                showSendForReviewModal,
                sendingForReview,
                sendForReviewObservaciones,
                openSendForReviewModal,
                closeSendForReviewModal,
                sendForReview,
            };
        },
        data() {
            return {
                liquidaciones: null,
                per_page: 10,
                fields: ['id', 'fecha_inicio', 'fecha_fin', 'estado', 'importe_total', 'opciones']
            }
        },
        created() {
            this.getLiquidaciones(1);
        },
        computed: {
            api_key() {
                return this.$store.getters.getUserToken;
            }
        },
        methods: {
            async getLiquidaciones(page, search = null) {
                const params = {
                    filters : {
                        per_page: this.per_page,
                        page: page
                    }
                };

                if (search) {
                    params.filters.status = search.status;
                    params.filters.fecha = search.fecha;
                }

                const res = await this.$store.dispatch(this.config.getVuexAlias('back.liquidaciones.abonos.index'), params);
                this.liquidaciones = res.data;
            },
            getColorEstado(estado) {
                switch(estado){
                    case 0 : return 'warning';
                    case 1 : return 'primary';
                    case 2 : return 'success';
                }
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal, borrado) {
                this.$modal.hide(modal);
                if(borrado) {
                    this.getLiquidaciones(1);
                }
            },
            borrarFiltros() {
                this.search = {
                    status: null,
                    fecha: null
                }
                this.getLiquidaciones(1);
            }
        },
        watch: {
            'search.fecha'(){
                if(this.search.fecha) {
                    this.getLiquidaciones(1);
                }
            }
        },
        components: {
            MainContent,
            ContentOrLoading,
            BorrarLiquidacionModal,
            FiltersBar,
            SendForReviewModal
        }
    }
</script>

<style scoped>
    .badge {
        padding: 0.75em 2em;
    }
    @media (min-width: 768px) {
        .btn-crear-liquidacion {
            width: auto !important;
        }
    }
</style>
